export function get(companyId, onlyOpen)
{
    let params = [];

    if (onlyOpen) {
        params.push(['filter[open]=1']);
    }

    return axios.get(route('api.manage.companies.invoices',  { company: companyId }) + `?${params.join('&')}`)
        .then(response => response.data);
}

export function sendMail(invoiceId)
{
    return axios.post(route('api.manage.invoices.sendMail', { invoice: invoiceId }))
        .then(response => response.data);
}
